import React, {useState, useEffect} from 'react';
import Time from '../../Time';
import '../../css/App.css';
import '../../css/bootstrap.min.css';
import bootstrap from 'bootstrap';
import Permissions from '../../Permissions';

class ScreenshotSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

        min:0,
        max:0,
        quality:0,
        ready:false,
        alertWindow:''
    }
    this.handleFormChange = this.handleFormChange.bind(this)
    this.setInitialValues = this.setInitialValues.bind(this)
    this.setInitialValues = this.setInitialValues.bind(this)
  }
  

    handleFormChange = (e) =>{
        this.setState({[e.target.id]: e.target.value});
    }

    setInitialValues = (results) =>{
        this.setState({min:results[0].numberValue})
        this.setState({max:results[1].numberValue})
        this.setState({quality:results[2].numberValue})
        this.setState({ready:true})
        console.log('Settings Loaded')
    }
    
    loadScreenshotSettings = async() =>{

        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
          };
          
          fetch("https://dashboard.realsexdoll.info/php/users/userssettings.php", requestOptions)
            .then(response => response.json())
            .then(result => 
                this.setInitialValues(result)
            )
            .catch(error => console.log('error', error));
        
    }

    saveSettings = async(e) =>{

        if(this.state.max < this.state.min){

        }

        e.preventDefault();

        var formdata = new FormData();
        formdata.append("min", this.state.min);
        formdata.append("max", this.state.max);
        formdata.append("quality", this.state.quality);
        
        var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow'
        };

        
        await fetch("https://dashboard.realsexdoll.info/php/users/savescreenshotsettings.php", requestOptions)
        .then(response => response.text())
        .then(result => console.log(result))
        .catch(error => console.log('error', error));

    }
    
    componentDidMount(){

        this.loadScreenshotSettings();

    }

  
  render() {

    let minInput;
    let maxInput;
    let qualityInput;

    if(this.state.ready){
        minInput = <input type="number" defaultValue={this.state.min} onChange={this.handleFormChange} id='min' min={1} class="form-control"></input>
        maxInput =  <input type="number" defaultValue={this.state.max} onChange={this.handleFormChange} id='max' min={2} class="form-control"></input>
        qualityInput = <input type="range" min="1" max="100" onChange={this.handleFormChange} defaultValue={this.state.quality} class="form-range" id="quality"></input>
    }

    

    return(
    <div className="col-12 bg-white py-3 mb-3">
        <h2>Screenshot Options</h2>
        <div className='row'>
            <form onSubmit={this.saveSettings}>
                <div className='col-12'>
                    <div className='row'>
                        <h6>Screenshot Interval</h6>
                        <div class="col-2 mb-3">
                            <label for="" class="form-label">Minimum</label>
                            {minInput}
                        </div>
                        <div class="col-2 mb-3">
                            <label for="" class="form-label">Maximum</label>
                            {maxInput}
                        </div>
                    </div>
                    <div className='row'>
                        <h6>Screenshot Quality</h6>
                        <div class="col-2 mb-3">
                            {qualityInput}
                            <p className='text-center'>{this.state.quality}</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div class="col-2 mb-3">
                            <button type='submit'>Save Settings</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>         
    </div>
    )
  }
}

export default ScreenshotSettings;